export default __webpack_public_path__ + "static/media/rank_icon.cbbfe064.svg";